import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Helper from "../../application/helper";
import { toast } from "react-toastify";

const slice = createSlice({
    name: "customerLedgerMemo",
    initialState: {},
    reducers: {
        updateField: (state, action) => {
            state[action.payload.field_name] = action.payload.value;
            return state;
        },
        setData: (state, action) => {
            state = action.payload;
            return state;
        },
        toServer: (state) => {
            let a = axios;
            if (state.id !== undefined && state.id) {
                a = a.put(
                    Helper.route("customerledgermemo.update", {
                        customerledgermemo: state.id,
                    }),
                    state
                );
            } else {
                a = a.post(Helper.route("customerledgermemo.store"), state);
            }
            a.then((res) => {
                toast.info("Operation Successful", {
                    position: toast.POSITION.BOTTOM_CENTER,
                });
                setTimeout(() => {
                    window.history.back();
                }, 1500);
            }).catch((res) => {
                Helper.validationErrorToast(res);
            });
            return state;
        },
        destroyFromServer: (state) => {
            let a = axios;
            if (state.id !== undefined && state.id) {
                a = a.delete(
                    Helper.route("customerledgermemo.destroy", {
                        customerledgermemo: state.id,
                    }),
                    state
                );
                a.then(() => {
                    toast.info("Operation Successful.", {
                        position: toast.POSITION.BOTTOM_CENTER,
                    });
                    setTimeout(() => {
                        window.history.back();
                    }, 1500);
                }).catch((res) => {
                    toast.error("Operation Failed", {
                        position: toast.POSITION.BOTTOM_CENTER,
                    });
                });
            }
            return state;
        },
    },
});
export const { updateField, setData, toServer, destroyFromServer } =
    slice.actions;

export default slice.reducer;
